import React from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";

import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";

const currentTheme = themes.morning;

interface Props {
  handleImageUpload: () => void;
  numColumns: number;
  iconComponent: React.JSX.Element;
  title?: string;
  subtitle?: string;
  bottomTags?: string[];
  withActionBarSpacing?: boolean;
}

function AddImageBaseCard({
  handleImageUpload,
  numColumns,
  iconComponent,
  title,
  subtitle,
  bottomTags,
  withActionBarSpacing = true,
}: Props): React.JSX.Element {
  const { width } = useWindowDimensions();
  const itemWidth = (width - Spacings.s1 * (numColumns + 1)) / numColumns;
  const itemHeight = (itemWidth / 3) * 4;
  const imageActionBarHeight = 27;

  return (
    <View>
      <TouchableOpacity onPress={() => handleImageUpload()}>
        <LinearGradient
          colors={["#e0c3fc", "#8ec5fc"]}
          style={[
            styles.container,
            {
              height:
                itemHeight + (withActionBarSpacing ? imageActionBarHeight : 0),
              width: itemWidth,
            },
          ]}
        >
          <View style={styles.centerContent}>
            <View style={styles.icon}>{iconComponent}</View>
            {title && <Text style={styles.title}>{title}</Text>}
            {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
          </View>
          {bottomTags && (
            <View style={styles.bottomTagsContainer}>
              {bottomTags.map((tag, index) => (
                <Text key={index} style={styles.tag}>
                  {tag}
                </Text>
              ))}
            </View>
          )}
        </LinearGradient>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    borderRadius: 7,
    padding: Spacings.s1,
  },
  centerContent: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    backgroundColor: "rgba(255,255,255,0.18)",
    borderRadius: 40,
    padding: Spacings.s3,
    alignItems: "center",
    marginVertical: Spacings.s2,
    justifyContent: "center",
  },
  title: {
    fontSize: currentTheme.typography.h3.size.mobile + 1,
    fontWeight: "bold",
    textAlign: "center",
    marginVertical: Spacings.s1,
    color: "#333333",
  },
  subtitle: {
    fontSize: currentTheme.typography.body.size.mobile - 1,
    textAlign: "center",
    color: "#333333",
  },
  bottomTagsContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: Spacings.s1,
  },
  tag: {
    color: "#333333",
    backgroundColor: "rgba(255,255,255,0.25)",
    borderRadius: 5,
    padding: Spacings.s1,
    margin: Spacings.s1,
    fontSize: currentTheme.typography.body.size.mobile - 2,
  },
});

export default AddImageBaseCard;
